if($('.js-accordion').length){

	$('.p-termsAccordion__title').click(function(){
		$(this).parent().toggleClass('is-open')
		$(this).next('.p-termsAccordion__detail').slideToggle();
	})

}
